<template>
  <div class="title">
    <span></span>
    我的收藏
  </div>
  <div class="list">
    <el-form :model="form" label-width="120px" inline>
      <el-form-item label="选择课程">
        <el-select v-model="LessonsValue" placeholder="请选择课程" @change="changHandel">
          <el-option :label="data.name" :value="data.code" v-for="(data,index) in Lessons" :key="index"/>
        </el-select>

      </el-form-item>
      <el-form-item label="活动类型">
        <el-select v-model="classId" placeholder="活动类型" @change="changHandel">
          <el-option :label="data.name" :value="data.id" v-for="(data,index) in clazz" :key="index"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div v-if="dataList.length>0">
      <div class="list-item" v-for="(data,index) in dataList" :key="index">
        <SketchIcon :type="icons[data.type_code].icon" />
        <span class="title">
          【{{icons[data.type_code].text}}】 信息检索/{{data.title}}</span>
        <span class="opr"></span>
      </div><div class="content">
          <span></span>

        <div class="tag">
          <span>收藏时间:</span>  {{new Date(data.create_time).format('yyyy年MM月dd日')}}
        </div>
      </div>

      <div style="margin: 10px 0">
        <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="page.total"
            :page-size="page.size"
            class="mt-4"
            @current-change="pageHandel"
        />
      </div>
    </div>
    <div v-else><el-empty  :image-size="300" description="无点赞记录"/></div>
  </div>
</template>
<script setup>

import {getidandname, getPresentAndPastLessons, getEvaluationFavorite} from "@/api/Learn-traces";
import SketchIcon from "@/component/SketchIcon";
import { icons} from "@/utils/dictionary.js";
import {ref} from "vue";
import {useRouter} from "vue-router/dist/vue-router";

const router =useRouter()
const Lessons = ref([])
getPresentAndPastLessons().then((data)=>{
  Lessons.value.push(...data.datas.data)
  console.log(Lessons.value)
})
const clazz = ref([])
getidandname().then((data)=>{
  clazz.value=data.datas.data
  if(!classId.value){
    classId.value=clazz.value[0].id
  }
})
const classId =ref(Number(router.currentRoute.value.query.classId))
const LessonsValue=ref(router.currentRoute.value.query.courseCode)
const page =ref({
    index:0,
    size:10,
    total:0
})
const dataList=ref([])
const loadData = (index) =>{
  page.value.index=index
  getEvaluationFavorite({
    course_code:LessonsValue.value,
    class_id:classId.value
  }).then(data=>{
    dataList.value.length=0
    dataList.value.push(...data.datas.data.list)
    page.value.total=data.datas.data.total
    console.log(dataList.value)
  })
}
const pageHandel = (index) =>{
  loadData(index)
}

const changHandel =()=>{
  loadData(0)
}
loadData(1)
</script>
<style lang="scss" scoped>
.title{
  font-family: Calibri;
  line-height: 60px;
  font-weight: 500;
  span{
    display: inline-block;
    height: 15px;
    width: 6px;
    background: red;
    margin: 0 10px;
    border-radius: 10px;
    vertical-align: middle;
  }
}
.list{
  background: white;
  padding: 20px;
  .list-item{
    border-bottom:  var(--el-fill-color-darker) solid 1px;
    padding: 10px 0;
    .content{
      padding: 4px 0;
    }
    .tag{
      padding: 4px 0;
      color: silver;
      font-size: 14px;
    }
  }
}
</style>
